import { render } from "./sti-sc-need-to-sti-sc-reverse-scan.vue?vue&type=template&id=30e6c44c&scoped=true&ts=true"
import script from "./sti-sc-need-to-sti-sc-reverse-scan.vue?vue&type=script&lang=ts"
export * from "./sti-sc-need-to-sti-sc-reverse-scan.vue?vue&type=script&lang=ts"

import "./sti-sc-need-to-sti-sc-reverse-scan.vue?vue&type=style&index=0&id=30e6c44c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e6c44c"]])

export default __exports__